import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import HubServerInfoService from "../api/hubServerInfo";
import { useDispatch, useSelector } from "react-redux";
import TemplateTable from "../common/Layout/templatePages/templateTable";
import handleNavigate from "../common/customFunctions/handleNavigate";
import { setAddHubServerAttribute } from "../store/addHubServerAttributeSlice";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../common/breadcrumbs";
import { getUrlVars } from "../utils/systemInfo";

const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
    height: "36px",
    backgroundColor: theme.palette.custom.buttonColor,
    color: theme.palette.custom.buttonTextColor,
    "&:hover": {
        backgroundColor: theme.palette.custom.buttonHoverColor,
        color: theme.palette.custom.buttonHoverTextColor,
        boxShadow: "none",
    },
    float: "right",
    width: "min-content",
    whiteSpace: "nowrap",
    padding: "1rem",
}));
function HubServerAttributes() {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const organziation = useSelector(({ organziation }) => organziation);
    const [loadingValue, setLoadingValue] = useState(true);
    const [hubServerAttributes, setHubServerAttributes] = useState([]);
    const id = String(getUrlVars()["serverId"]);
    const breadcrumbs = [
        { id: 0, name: "Home", href: "/" },
        { id: 1, name: t("HUB Server Config"), href: "hubServerInfoApi" },
        { id: 2, name: "HUB Server Attributes" },
    ];
    useEffect(() => {
        if (organziation) {
            const orgObj =
                organziation ?? JSON.parse(localStorage.getItem("defaultOrganization"));
            const apiKey = orgObj?.api_key_list?.[0]?.key;
            HubServerInfoService.GetHUBServerInfoAttribute({
                hub_server_info_attribute_id: "",
                hub_server_info_id: id,
                name: "",
                status: "",
                apiKey,
            })
                .then((jsonAttribute) => {
                    if (jsonAttribute?.data?.hub_server_info_attributes?.length) {
                        setHubServerAttributes(jsonAttribute.data?.hub_server_info_attributes);
                    }
                    setLoadingValue(false);
                })
                .catch((errorr) => {
                    setLoadingValue(false);
                    if (process.env.NODE_ENV === "development")
                        console.log("GetHUBServerInfoAttributeerror", errorr);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleButton = (event, buttonType, row) => {
        if (buttonType === "edit") {
            handleEdit(event, row);
        }
    };
    const handleEdit = (event, row) => {
        dispatch(setAddHubServerAttribute(row));
        event.stopPropagation();
        handleNavigate(event, navigate, `/addEditHubServerAttribute?serverId=${id}&id=${row.hub_server_info_attribute_id}`);
    };
    const handleAddNew = (event) => {
        handleNavigate(event, navigate, `/addEditHubServerAttribute?serverId=${id}`);
    };
    return (
        <Box
            sx={{
                p: "12px",
                backgroundColor: theme.palette.custom.backgroundColor,
            }}
        >
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: { xs: "block", sm: "center" },
                    gap: "1rem",
                    mb: "1rem",
                    flexWrap: "wrap"
                }}
            >
                <Typography
                    sx={{ fontSize: "45px", mb: 0, color: theme.palette.custom.text }}
                    variant="h2"
                    gutterBottom
                >
                    {t("HUB Server Attributes")}
                </Typography>
                <StyledButton variant="contained" onClick={handleAddNew}>
                    {t("Add New Attribute")}
                </StyledButton>
            </Box>
            <Divider
                sx={{ mb: "10px", backgroundColor: theme.palette.custom.borderColor }}
            />
            <TemplateTable
                headCells={[
                    { id: "name" },
                    { id: "value" },
                    { id: "status" },
                    { id: "description" },
                    {
                        id: "action",
                        buttons: ["edit"],
                    },
                ]}
                handleButton={handleButton}
                itemsList={hubServerAttributes}
                itemId="name"
                loading={loadingValue}
                searchAttributes={["name", "description", "value"]}
                allowExport
                exportTitle={t("HUB Server Attributes")}
            />
        </Box>
    );
}
export default HubServerAttributes;